import type { CycleHeaderState } from "../hooks/resolveCycleHeaderState";

/**
 * Which part of an IVF cycle Home is about, after stimulation as well as
 * during it. The cycle header state already knows the step; the Home's own
 * variants do not change between stimulation and the transfer, so without this
 * the day before retrieval and transfer day read as stimulation.
 */
export type IvfHomeStep = "stimulation" | "retrieval" | "embryos" | "transfer";

export function ivfHomeStep(
  kind: CycleHeaderState["kind"],
): IvfHomeStep | null {
  switch (kind) {
    case "stim_monitoring_next":
    case "stim_med_next":
    case "stim_generic":
      return "stimulation";
    case "stim_trigger_logged":
    case "retrieval_scheduled":
      return "retrieval";
    case "fertilization":
    case "embryo_dev":
      return "embryos";
    case "transfer_scheduled":
      return "transfer";
    default:
      return null;
  }
}
